import AcikRizaMetni from '@/src/constants/htmls/acik-riza-metni.html';
import AydinlatmaMetniIsOrtagi from '@/src/constants/htmls/aydinlatma-metni-is-ortagi.html';
import AydinlatmaMetniUsteri from '@/src/constants/htmls/aydinlatma-metni-musteri.html';
import CerezBildirimi from '@/src/constants/htmls/cerez-bildirimi.html';
import GizlilikBildirimi from '@/src/constants/htmls/gizlilik-bildirimi.html';
import IptalVeIadeKosullari from '@/src/constants/htmls/iptal-ve-iade-kosullari';
import KullaniciSozlesmesi from '@/src/constants/htmls/kullanici-sozlesmesi.html';
import KullanimKosullari from '@/src/constants/htmls/kullanim-kosullari.html';
export interface IMockData {
  [id: string]: {
    mainTitle: string;
    redirectTitle: string;
    template: string;
    fileUrl: string;
    url: string;
    urlTitle: string;
    page?: any;
    seoInfo?: any;
  };
}

export const mockData: IMockData = {
  'bilgi-guvenligi-politikasi': {
    mainTitle: 'HangiKredi KOBİ’nin Bilgi Güvenliği Politikası',
    redirectTitle: 'Bilgi Güvenliği Politikamız',
    template: '',
    fileUrl: '',
    url: '/assets/files/bilgi-guvenligi-politikasi.pdf',
    urlTitle: 'Bilgi Güvenliği Politikası',
    page: {
      id: 1,
      code: 'smeloanroof-bilgi-guvenligi-politikasi',
      name: 'Kobi Çatı Bilgi Güvenliği Politikası',
      category: 'Hakkımızda',
      midCategory: null,
      subCategory: null,
      type: 'About Page',
      sharingType: 'WebSite',
      heroButtonText: null,
      whatIsTitle: null,
      desktopImagePath1: null,
      mobileImagePath1: null,
      desktopImagePath2: null,
      mobileImagePath2: null,
    },
    seoInfo: {
      title: 'Bilgi Güvenliği Politikamız',
      metaDescription: '',
      canonicalUrl: 'https://www.hangikredikobi.com/assets/files/bilgi-guvenligi-politikasi.pdf',
      headingTitle: 'KOBİ’lerin Finansal İhtiyaçlarında, HangiKredi KOBİ Yanında!!',
      heroDescription:
        "En avantajlı finansal ürünler Hangikredi’de Kobi'de! KOBİ'lere özel ürünleri kullanmak için ücretsiz hesaplama ve başvuru yapabilirsiniz.",
      friendlyUrl: null,
      entity: null,
      entityId: null,
      statusParameters: 0,
      image: 'https://statics-hangikredi.mncdn.com/images/hklogo.png',
      badge: null,
    },
  },
  'aydinlatma-metni-musteri': {
    mainTitle: 'Kişisel Verilerin Korunması ve İşlenmesine İlişkin Müşteri Aydınlatma Metni',
    redirectTitle: 'Aydınlatma Metni (Müşteri)',
    template: AydinlatmaMetniUsteri,
    fileUrl: '',
    url: '/hakkimizda/aydinlatma-metni-musteri',
    urlTitle: 'Aydınlatma Metni (Müşteri)',
    page: {
      id: 1,
      code: 'smeloanroof-bilgi-guvenligi-politikasi',
      name: 'Kobi Çatı Aydınlatma Metni (Müşteri)',
      category: 'Hakkımızda',
      midCategory: null,
      subCategory: null,
      type: 'About Page',
      sharingType: 'WebSite',
      heroButtonText: null,
      whatIsTitle: null,
      desktopImagePath1: null,
      mobileImagePath1: null,
      desktopImagePath2: null,
      mobileImagePath2: null,
    },
    seoInfo: {
      title: 'Aydınlatma Metni (Müşteri)',
      metaDescription: 'Kişisel Verilerin Korunması ve İşlenmesine İlişkin Müşteri Aydınlatma Metni',
      canonicalUrl: 'https://www.hangikredikobi.com/hakkimizda/aydinlatma-metni-musteri',
      headingTitle: 'Kişisel Verilerin Korunması ve İşlenmesine İlişkin Müşteri Aydınlatma Metni',
      heroDescription: 'Kişisel Verilerin Korunması ve İşlenmesine İlişkin Müşteri Aydınlatma Metni',
      friendlyUrl: null,
      entity: null,
      entityId: null,
      statusParameters: 0,
      image: 'https://statics-hangikredi.mncdn.com/images/hklogo.png',
      badge: null,
    },
  },
  'aydinlatma-metni-is-ortagi': {
    mainTitle: 'Kişisel Verilerin Korunması ve İşlenmesine İlişkin İş Ortağı Aydınlatma Metni',
    redirectTitle: 'Aydınlatma Metni (İş Ortağı)',
    template: AydinlatmaMetniIsOrtagi,
    fileUrl: '',
    url: '/hakkimizda/aydinlatma-metni-is-ortagi',
    urlTitle: 'Aydınlatma Metni (İş Ortağı)',
    page: {
      id: 1,
      code: 'smeloanroof-aydinlatma-metni-is-ortagi',
      name: 'Kobi Çatı Aydınlatma Metni (İş Ortağı)',
      category: 'Hakkımızda',
      midCategory: null,
      subCategory: null,
      type: 'About Page',
      sharingType: 'WebSite',
      heroButtonText: null,
      whatIsTitle: null,
      desktopImagePath1: null,
      mobileImagePath1: null,
      desktopImagePath2: null,
      mobileImagePath2: null,
    },
    seoInfo: {
      title: 'Aydınlatma Metni (İş Ortağı)',
      metaDescription: 'Kişisel Verilerin Korunması ve İşlenmesine İlişkin İş Ortağı Aydınlatma Metni',
      canonicalUrl: 'https://www.hangikredikobi.com/hakkimizda/aydinlatma-metni-is-ortagi',
      headingTitle: 'Kişisel Verilerin Korunması ve İşlenmesine İlişkin Müşteri Aydınlatma Metni',
      heroDescription: 'Kişisel Verilerin Korunması ve İşlenmesine İlişkin Müşteri Aydınlatma Metni',
      friendlyUrl: null,
      entity: null,
      entityId: null,
      statusParameters: 0,
      image: 'https://statics-hangikredi.mncdn.com/images/hklogo.png',
      badge: null,
    },
  },
  // 'aydinlatma-metni-ise-alim': {
  //   mainTitle: 'İşe Alım Süreci İçin Aydınlatma Metni',
  //   redirectTitle: 'Aydınlatma Metni (İşe Alım)',
  //   template: AydinlatmaMetniIseAlim,
  //   fileUrl: '',
  //   url: '/hakkimizda/aydinlatma-metni-ise-alim',
  //   urlTitle: 'Aydınlatma Metni (İşe Alım)',
  // },
  'acik-riza-metni': {
    mainTitle: "HangiKredi Kobi'nin Kişisel Verilerin Korunması ve İşlenmesine İlişkin Açık Rıza Metni",
    redirectTitle: 'Açık Rıza Metni',
    template: AcikRizaMetni,
    fileUrl: '',
    url: '/hakkimizda/acik-riza-metni',
    urlTitle: 'Açık Rıza Metni',
    page: {
      id: 1,
      code: 'smeloanroof-acik-riza-metni',
      name: 'Kobi Çatı Hakkımızda',
      category: 'Hakkımızda',
      midCategory: null,
      subCategory: null,
      type: 'About Page',
      sharingType: 'WebSite',
      heroButtonText: null,
      whatIsTitle: null,
      desktopImagePath1: null,
      mobileImagePath1: null,
      desktopImagePath2: null,
      mobileImagePath2: null,
    },
    seoInfo: {
      title: 'Açık Rıza Metni',
      metaDescription: "HangiKredi'nin Kişisel Verilerin Korunması ve İşlenmesine İlişkin Açık Rıza Metni",
      canonicalUrl: 'https://www.hangikredikobi.com/hakkimizda/acik-riza-metni',
      headingTitle: 'Kişisel Verilerin Korunması ve İşlenmesine İlişkin Müşteri Aydınlatma Metni',
      heroDescription: 'Kişisel Verilerin Korunması ve İşlenmesine İlişkin Müşteri Aydınlatma Metni',
      friendlyUrl: null,
      entity: null,
      entityId: null,
      statusParameters: 0,
      image: 'https://statics-hangikredi.mncdn.com/images/hklogo.png',
      badge: null,
    },
  },
  'ilgili-kisi-basvuru-formu': {
    mainTitle: 'İlgili Kişi Başvuru Formu',
    redirectTitle: 'İlgili Kişi Başvuru Formu',
    template: '',
    fileUrl: '',
    url: 'https://www.hangikredi.com/dist/files/Basvuru_Formu_Aydinlatma_Metni.pdf',
    urlTitle: 'İlgili Kişi Başvuru Formu',
    page: {
      id: 1,
      code: 'smeloanroof-ilgili-kisi-basvuru',
      name: 'Kobi Çatı Açık Rıza Metni',
      category: 'Hakkımızda',
      midCategory: null,
      subCategory: null,
      type: 'About Page',
      sharingType: 'WebSite',
      heroButtonText: null,
      whatIsTitle: null,
      desktopImagePath1: null,
      mobileImagePath1: null,
      desktopImagePath2: null,
      mobileImagePath2: null,
    },
    seoInfo: {
      title: 'İlgili Kişi Başvuru Formu',
      metaDescription: 'İlgili Kişi Başvuru Formu',
      canonicalUrl: 'https://www.hangikredi.com/dist/files/Basvuru_Formu_Aydinlatma_Metni.pdf',
      headingTitle: 'Kişisel Verilerin Korunması ve İşlenmesine İlişkin Müşteri Aydınlatma Metni',
      heroDescription: 'Kişisel Verilerin Korunması ve İşlenmesine İlişkin Müşteri Aydınlatma Metni',
      friendlyUrl: null,
      entity: null,
      entityId: null,
      statusParameters: 0,
      image: 'https://statics-hangikredi.mncdn.com/images/hklogo.png',
      badge: null,
    },
  },
  'iptal-ve-iade-kosullari': {
    mainTitle: 'İptal ve İade Koşulları',
    redirectTitle: 'İptal ve İade Koşulları',
    template: IptalVeIadeKosullari,
    fileUrl: '',
    url: '/hakkimizda/iptal-ve-iade-kosullari',
    urlTitle: 'İptal ve İade Koşulları',
    page: {
      id: 1,
      code: "smeloanroof-iptal-ve-iade-kosullari':",
      name: 'Kobi Çatı İptal ve İade Koşulları',
      category: 'Hakkımızda',
      midCategory: null,
      subCategory: null,
      type: 'About Page',
      sharingType: 'WebSite',
      heroButtonText: null,
      whatIsTitle: null,
      desktopImagePath1: null,
      mobileImagePath1: null,
      desktopImagePath2: null,
      mobileImagePath2: null,
    },
    seoInfo: {
      title: 'Gizlilik Bildirimi',
      metaDescription: 'Gizlilik Bildirimi',
      canonicalUrl: 'https://www.hangikredikobi.com/hakkimizda/gizlilik-bildirimi',
      headingTitle: 'Kişisel Verilerin Korunması ve İşlenmesine İlişkin Müşteri Aydınlatma Metni',
      heroDescription: 'Kişisel Verilerin Korunması ve İşlenmesine İlişkin Müşteri Aydınlatma Metni',
      friendlyUrl: null,
      entity: null,
      entityId: null,
      statusParameters: 0,
      image: 'https://statics-hangikredi.mncdn.com/images/hklogo.png',
      badge: null,
    },
  },
  'gizlilik-bildirimi': {
    mainTitle: 'Gizlilik Bildirimi',
    redirectTitle: 'Gizlilik Bildirimi',
    template: GizlilikBildirimi,
    fileUrl: '',
    url: '/hakkimizda/gizlilik-bildirimi',
    urlTitle: 'Gizlilik Bildirimi',
    page: {
      id: 1,
      code: "smeloanroof-gizlilik-bildirimi':",
      name: 'Kobi Çatı Gizlilik Bildirimi',
      category: 'Hakkımızda',
      midCategory: null,
      subCategory: null,
      type: 'About Page',
      sharingType: 'WebSite',
      heroButtonText: null,
      whatIsTitle: null,
      desktopImagePath1: null,
      mobileImagePath1: null,
      desktopImagePath2: null,
      mobileImagePath2: null,
    },
    seoInfo: {
      title: 'Gizlilik Bildirimi',
      metaDescription: 'Gizlilik Bildirimi',
      canonicalUrl: 'https://www.hangikredikobi.com/hakkimizda/gizlilik-bildirimi',
      headingTitle: 'Kişisel Verilerin Korunması ve İşlenmesine İlişkin Müşteri Aydınlatma Metni',
      heroDescription: 'Kişisel Verilerin Korunması ve İşlenmesine İlişkin Müşteri Aydınlatma Metni',
      friendlyUrl: null,
      entity: null,
      entityId: null,
      statusParameters: 0,
      image: 'https://statics-hangikredi.mncdn.com/images/hklogo.png',
      badge: null,
    },
  },
  'cerez-bildirimi': {
    mainTitle: 'Çerez Bildirimi',
    redirectTitle: 'Çerez Bildirimi',
    template: CerezBildirimi,
    fileUrl: '',
    url: '/hakkimizda/cerez-bildirimi',
    urlTitle: 'Çerez Bildirimi',
    page: {
      id: 1,
      code: "smeloanroof-cerez-bildirimi':",
      name: 'Kobi Çatı Çerez Bildirimi',
      category: 'Hakkımızda',
      midCategory: null,
      subCategory: null,
      type: 'About Page',
      sharingType: 'WebSite',
      heroButtonText: null,
      whatIsTitle: null,
      desktopImagePath1: null,
      mobileImagePath1: null,
      desktopImagePath2: null,
      mobileImagePath2: null,
    },
    seoInfo: {
      title: 'Çerez Bildirimi',
      metaDescription: 'Çerez Bildirimi',
      canonicalUrl: 'https://www.hangikredikobi.com/hakkimizda/cerez-bildirimi',
      headingTitle: 'Kişisel Verilerin Korunması ve İşlenmesine İlişkin Müşteri Aydınlatma Metni',
      heroDescription: 'Kişisel Verilerin Korunması ve İşlenmesine İlişkin Müşteri Aydınlatma Metni',
      friendlyUrl: null,
      entity: null,
      entityId: null,
      statusParameters: 0,
      image: 'https://statics-hangikredi.mncdn.com/images/hklogo.png',
      badge: null,
    },
  },
  'kullanici-sozlesmesi': {
    mainTitle: 'Kullanıcı Sözleşmesi',
    redirectTitle: 'Kullanıcı Sözleşmesi',
    template: KullaniciSozlesmesi,
    fileUrl: '',
    url: '/hakkimizda/kullanici-sozlesmesi',
    urlTitle: 'Kullanıcı Sözleşmesi',
    page: {
      id: 1,
      code: "smeloanroof-kullanici-sozlesmesi':",
      name: 'Kobi Çatı Kullanıcı Sözleşmesi',
      category: 'Hakkımızda',
      midCategory: null,
      subCategory: null,
      type: 'About Page',
      sharingType: 'WebSite',
      heroButtonText: null,
      whatIsTitle: null,
      desktopImagePath1: null,
      mobileImagePath1: null,
      desktopImagePath2: null,
      mobileImagePath2: null,
    },
    seoInfo: {
      title: 'Kullanıcı Sözleşmesi',
      metaDescription:
        "HangiKredi Kobi hizmetleri hakkında hüküm ve şartları Kullanıcı Sözleşmesi'nden öğrenebilirsiniz.",
      canonicalUrl: 'https://www.hangikredikobi.com/hakkimizda/kullanici-sozlesmesi',
      headingTitle: 'Kişisel Verilerin Korunması ve İşlenmesine İlişkin Müşteri Aydınlatma Metni',
      heroDescription: 'Kişisel Verilerin Korunması ve İşlenmesine İlişkin Müşteri Aydınlatma Metni',
      friendlyUrl: null,
      entity: null,
      entityId: null,
      statusParameters: 0,
      image: 'https://statics-hangikredi.mncdn.com/images/hklogo.png',
      badge: null,
    },
  },
  // 'iletisim': {
  //   mainTitle: 'İletişim Formu',
  //   redirectTitle: 'İletişim Formu',
  //   template: AcikRizaMetni,
  //   fileUrl: '',
  //   url: '/hakkimizda/iletisim',
  //   urlTitle: 'İletişim Formu',
  // },
  'kullanim-kosullari': {
    mainTitle: 'HangiKrediKobi.com Kullanım Koşulları',
    redirectTitle: 'Kullanım Koşulları',
    template: KullanimKosullari,
    fileUrl: '',
    url: '/hakkimizda/kullanim-kosullari',
    urlTitle: 'Kullanım Koşulları',
    page: {
      id: 1,
      code: "smeloanroof-kullanim-kosullari':",
      name: 'Kobi Çatı Kullanıcı Sözleşmesi',
      category: 'Hakkımızda',
      midCategory: null,
      subCategory: null,
      type: 'About Page',
      sharingType: 'WebSite',
      heroButtonText: null,
      whatIsTitle: null,
      desktopImagePath1: null,
      mobileImagePath1: null,
      desktopImagePath2: null,
      mobileImagePath2: null,
    },
    seoInfo: {
      title: 'Kullanım Koşulları',
      metaDescription: 'HangiKredi.com Kullanım Koşulları',
      canonicalUrl: 'https://www.hangikredikobi.com/hakkimizda/kullanim-kosullari',
      headingTitle: 'Kişisel Verilerin Korunması ve İşlenmesine İlişkin Müşteri Aydınlatma Metni',
      heroDescription: 'Kişisel Verilerin Korunması ve İşlenmesine İlişkin Müşteri Aydınlatma Metni',
      friendlyUrl: null,
      entity: null,
      entityId: null,
      statusParameters: 0,
      image: 'https://statics-hangikredi.mncdn.com/images/hklogo.png',
      badge: null,
    },
  },
  // 'hakkimizda': {
  //   mainTitle:
  //     "HangiKredi'nin kişisel Verilerin Korunması ve işlenmesine İlişkin Açık Rıza Metni",
  //   redirectTitle: 'Hakkımızda',
  //   template: AcikRizaMetni,
  //   fileUrl: '',
  //   url: '/hakkimizda',
  //   urlTitle: 'Hakkımızda',
  //   active: false,
  // },
};
